"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const CommentFormImpl_1 = require("../impl/CommentFormImpl");
class CommentForm extends CommentFormImpl_1.default {
    render() {
        return (React.createElement("form", { onSubmit: this.onCommentSubmit },
            React.createElement("div", { className: 'row' },
                React.createElement("div", { className: 'col-md-6' },
                    React.createElement("div", { className: 'form-item form-name' },
                        React.createElement("input", { className: 'form-control', type: 'text', required: true, minLength: 3, onChange: this.nameChange, placeholder: 'Your name', value: this.state.name }))),
                React.createElement("div", { className: 'col-md-6' },
                    React.createElement("div", { className: 'form-item form-email' },
                        React.createElement("input", { className: 'form-control', type: 'email', required: true, onChange: this.emailChange, placeholder: 'Your e-mail', value: this.state.email }))),
                React.createElement("div", { className: 'col-md-12' },
                    React.createElement("div", { className: 'form-item form-textarea-wrapper' },
                        React.createElement("textarea", { className: 'form-control', rows: 3, required: true, minLength: 3, onChange: this.commentChange, placeholder: 'Message', value: this.state.text }))),
                React.createElement("div", { className: 'col-md-12' },
                    React.createElement("div", { className: 'form-actions' },
                        React.createElement("input", { type: 'submit', defaultValue: 'Comment', className: 'pi-btn' }))))));
    }
}
exports.default = CommentForm;
